import { useDelete } from '../../../../api/react-query';

export function useConfigDelete({ params }) {
  const {
    mutateAsync: deleteConfig,
    isLoading: isDeleting,
    error,
  } = useDelete({
    url: 'config/configs',
    params: params,
  });

  return {
    deleteConfig,
    isDeleting,
    error,
  };
}
